/**
 * CitationFooter: the whitepaper attribution shown at the foot of every apex
 * page (Landing, Mission, About). The whitepaper is the conceptual foundation
 * for the entire platform; CC BY-SA 4.0 attribution is required when
 * paraphrasing or quoting from it. The DOI is the citable identifier (it pins a wiki
 * revision); the wiki main page link is the live document and is sufficient
 * when the section being cited isn't called out inline.
 *
 * Shared by more than one page, so it lives in its own module rather than being
 * duplicated per page.
 */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import {
    WHITEPAPER_WIKI_URL,
    WHITEPAPER_DOI,
    WHITEPAPER_DOI_URL,
} from './platformContent';
import './CitationFooter.css';

export default function CitationFooter() {
    return (
        <section className="platform-citation py-4 bg-light border-top">
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={8}>
                        <p className="small text-muted mb-1">
                            Content on this page draws from the working
                            whitepaper{' '}
                            <em>
                                Foundation of a Reciprocal Integrated Learning
                                Ecosystem (RILE): Learning from the Ground Up
                            </em>{' '}
                            by Janelle M. Johnson, PhD, Joshua Kumin, and
                            Ranjidha Rajan, PhD.{' '}
                            <a
                                href={WHITEPAPER_DOI_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                doi:{WHITEPAPER_DOI}
                            </a>
                            .
                        </p>
                        <p className="small text-muted mb-0">
                            Licensed under{' '}
                            <a
                                href="https://creativecommons.org/licenses/by-sa/4.0/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                CC BY-SA 4.0
                            </a>
                            . Read the full whitepaper at the{' '}
                            <a
                                href={WHITEPAPER_WIKI_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Colorado STEM Ecosystem wiki
                            </a>
                            .
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
